import { render, staticRenderFns } from "./subNgo.vue?vue&type=template&id=71041302&scoped=true&"
import script from "./subNgo.vue?vue&type=script&lang=js&"
export * from "./subNgo.vue?vue&type=script&lang=js&"
import style0 from "./subNgo.vue?vue&type=style&index=0&id=71041302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71041302",
  null
  
)

export default component.exports